import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const Check = React.memo(
  ({ width = 81, fill = variables['colors-mc-primary'], viewBox = '0 0 81 82' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <path
        d='M79.725 34.0639L77.825 38.7639C77.225 40.3639 77.225 42.0639 77.825 43.6639L79.725 48.3639C80.825 51.1639 79.925 54.3639 77.425 56.1639L73.225 59.0639C71.825 60.0639 70.925 61.5639 70.525 63.1639L69.625 68.1639C69.025 71.1639 66.525 73.3639 63.525 73.4639L58.425 73.6639C56.725 73.7639 55.125 74.4639 53.925 75.6639L50.425 79.3639C48.325 81.5639 45.025 82.0639 42.425 80.5639L38.025 77.9639C36.525 77.0639 34.825 76.8639 33.125 77.2639L28.125 78.4639C25.225 79.1639 22.125 77.7639 20.725 75.0639L18.425 70.4639C17.625 68.9639 16.325 67.7639 14.725 67.2639L9.925 65.6639C7.025 64.6639 5.225 61.8639 5.525 58.8639L6.025 53.7639C6.225 52.0639 5.725 50.3639 4.625 49.0639L1.425 45.0639C-0.475 42.6639 -0.475 39.3639 1.425 36.9639L4.625 32.9639C5.725 31.6639 6.225 29.9639 6.025 28.2639L5.525 23.1639C5.225 20.1639 7.025 17.3639 9.925 16.3639L14.725 14.7639C16.325 14.2639 17.625 13.0639 18.425 11.5639L20.725 6.96393C22.125 4.26393 25.125 2.86393 28.125 3.56393L33.125 4.76393C34.725 5.16393 36.525 4.96393 38.025 4.06393L42.425 1.46393C45.025 -0.0360666 48.325 0.363932 50.425 2.66393L53.925 6.36393C55.125 7.56393 56.725 8.36393 58.425 8.36393L63.525 8.56393C66.525 8.66393 69.125 10.8639 69.625 13.8639L70.525 18.8639C70.825 20.5639 71.825 22.0639 73.225 22.9639L77.425 25.8639C79.925 28.0639 80.925 31.2639 79.725 34.0639Z'
        fill={fill}
      />
      <g opacity='0.15'>
        <path
          d='M61.2242 73.2639C60.7242 73.2639 60.2242 73.3639 59.8242 73.4639L63.4242 73.2639C63.9242 73.2639 64.3242 73.1639 64.8242 73.0639L61.2242 73.2639Z'
          fill='black'
        />
      </g>
      <path d='M24.2246 34.8639L36.7246 49.1639L62.3246 28.5639' fill='#37D6C9' />
      <path
        d='M33.7253 56.5639C32.3253 56.5639 30.9253 55.9639 29.9253 54.8639L17.4253 40.5639C15.6253 38.4639 15.8253 35.3639 17.8253 33.4639C19.9253 31.6639 23.0253 31.8639 24.9253 33.8639L34.3253 44.5639L56.2253 26.9639C58.3253 25.2639 61.5253 25.5639 63.2253 27.7639C64.9253 29.9639 64.6253 33.0639 62.4253 34.7639L36.8253 55.4639C35.9253 56.1639 34.8253 56.5639 33.7253 56.5639Z'
        fill='white'
      />
    </svg>
  )
);
Check.displayName = 'Check';

export default Check;
